/*eslint-disable*/
import { reactive, getCurrentInstance } from "vue";
import { useRouter } from "vue-router";
import { SharedMap } from "fluid-framework";
import { AzureClient } from "@fluidframework/azure-client";
import api from "@/api";
import main from "@/api/main";

var serverLocation = main.getServerLocation();

export function useAssignmentTaskCreator() {
  let that = getCurrentInstance().proxy;
  const router = useRouter();

  const containerSchema = reactive({
    initialObjects: {
      mindHistory: SharedMap,
      mindData: SharedMap,
      isDeleting: SharedMap,
      coworkMode: SharedMap,
    },
  });

  // 初始化 Azure 客戶端
  const initializeAzureClient = async () => {
    localStorage.removeItem("cachedFluidRelayToken"); //初始化先移除localStorage

    const fluidConfig = await api.mindmapAPI.getFluidRelayConfig();
    let dataCenter = (serverLocation.includes("cn")) ? "china" : "global";

    console.log("fromInfo", that.fromInfo, localStorage.getItem("id_token"),  that.profile)
    
    const serviceConfig = {
      connection: {
        type: "remote",
        tenantId: fluidConfig[dataCenter]?.fluidRelayTenantId,
        tokenProvider: new api.MyAzTokenProvider(api.mindmapAPI.fluidTokenUrl, {
          idToken: "",
          id: that.fromInfo?.seat || that.profile?.teammodelId || "",
          name: that.fromInfo?.name == "" ? 'anonymous' : (that.fromInfo?.name || that.profile?.name || "anonymous"),
        }),
        endpoint: fluidConfig[dataCenter]?.fluidRelayEndpoint,
      },
    };
    return new AzureClient(serviceConfig);
  };

  // 獲取 Fluid 心智圖資料
  const getFluidMindData = async (fluidContainerId) => {
    if (!fluidContainerId) {
      console.error('fluidContainerId 為空');
      return null;
    }

    let retryCount = 0;
    const maxRetries = 3;
    const retryDelay = 2000; // 2秒

    const tryGetContainer = async () => {
      try {
        console.log(`嘗試獲取容器 ${retryCount + 1}/${maxRetries}:`, fluidContainerId);
        const client = await initializeAzureClient();
        const result = await client.getContainer(fluidContainerId, containerSchema, "2");
        const container = result.container;

        // 等待容器完全載入
        await new Promise(resolve => setTimeout(resolve, 1500));

        const fluidMindData = container.initialObjects.mindData;
        console.log('容器資料大小:', fluidMindData?.size || 0);

        // 檢查是否有資料
        if (fluidMindData && fluidMindData.size > 0) {
          // 創建資料副本
          const data = new Map();
          for (const [key, value] of fluidMindData) {
            data.set(key, value);
          }

          // 安全釋放容器
          if (container.isDirty) {
            container.once("saved", () => {
              console.log("讀取完成，容器已保存並釋放");
              container.dispose();
            });
          } else {
            container.dispose();
          }

          console.log('成功獲取心智圖資料，資料項目數:', data.size);
          return data;
        } else {
          console.warn('容器中沒有心智圖資料或資料未載入完成');

          // 安全釋放容器
          if (container.isDirty) {
            container.once("saved", () => {
              console.log("容器已保存並釋放");
              container.dispose();
            });
          } else {
            container.dispose();
          }

          // 如果是第一次嘗試且沒有資料，嘗試重試
          if (retryCount === 0) {
            retryCount++;
            console.log(`資料為空，等待 ${retryDelay / 1000} 秒後重試...`);
            return new Promise(resolve => setTimeout(() => resolve(tryGetContainer()), retryDelay));
          }
          return null;
        }
      } catch (error) {
        console.error(`嘗試 ${retryCount + 1}/${maxRetries} 失敗:`, error);
        if (retryCount < maxRetries - 1) {
          retryCount++;
          console.log(`等待 ${retryDelay / 1000} 秒後重試...`);
          return new Promise(resolve => setTimeout(() => resolve(tryGetContainer()), retryDelay));
        } else {
          console.error(`已重試 ${maxRetries} 次，仍然失敗`);
          return null; // 改為回傳 null 而不是拋出錯誤
        }
      }
    };

    return tryGetContainer();
  };

  // 創建作業任務（從現有心智圖模板）
  const createMindCollectFromTemplate = async (mindMapInfo) => {
    if (!that.profile || !that.profile.teammodelId) {
      throw new Error('使用者資訊不完整');
    }

    // 1. 先創建範本心智圖
    let templateData = {
      "mindmapName": `${mindMapInfo.mindmapName}_${that.$t("mindmap.mindmapHome.taskSuffix")}_${that.$t("mindmap.mindmapHome.template")}`,
      "mindmapCreator": {
        "id": that.profile.teammodelId,
        "name": that.profile.name,
      },
      "mindSubCreator": {
        "id": "0",
        "name": "teacher",
      },
      "collectId": "", // 稍後會設定
      "mindSubCreatorEditKey": "",
      "mindmapData": "",
      "fluidContainerId": "",
      "openCowork": false,
      "coworkMode": "view",
    };

    let container = null;

    try {
      // 1. 先獲取原心智圖資料
      const copyMindData = await getFluidMindData(mindMapInfo.fluidContainerId);

      // 2. 初始化 Azure 客戶端並創建新容器
      const client = await initializeAzureClient();
      const result = await client.createContainer(containerSchema, "2");
      container = result.container;
      templateData.fluidContainerId = await container.attach();

      // 等待容器完全初始化
      await new Promise(resolve => setTimeout(resolve, 1000));

      const fluidIsDeleting = container.initialObjects.isDeleting;
      const fluidCoworkMode = container.initialObjects.coworkMode;
      let fluidMindData = container.initialObjects.mindData;

      console.log('開始寫入心智圖資料到新容器');
      if (copyMindData) {
        for (const [key, value] of copyMindData) {
          fluidMindData.set(key, value);
        }

        // 等待資料同步完成
        await new Promise(resolve => setTimeout(resolve, 2000));

        // 驗證資料是否成功寫入
        console.log('寫入後容器資料大小:', fluidMindData.size);
        if (fluidMindData.size === 0) {
          console.warn('資料寫入失敗，容器為空');
        }
      } else {
        console.warn('原始心智圖資料為空，跳過資料複製');
      }

      // 設定 Fluid 狀態
      fluidIsDeleting.set('data', false);
      fluidCoworkMode.set('data', JSON.stringify({
        "coworkMode": "edit",
        "openCowork": true,
      }));

      // 2. 先創建收集區
      const collectData = {
        "mindCollectName": `${mindMapInfo.mindmapName}_${that.$t("mindmap.mindmapHome.taskSuffix")}`,
        "creator": {
          "id": that.profile.teammodelId,
          "name": that.profile.name,
        },
        "openSubmit": true,
        "allowViewOthers": true,
        "stopSubmitTime": 0,
        "collectType": "task"
      };

      const collectRes = await api.mindmapAPI.createMindCollect(collectData);

      // 3. 將收集區 ID 加入範本資料
      templateData.collectId = collectRes.id;

      // 4. 創建範本心智圖
      const templateRes = await api.mindmapAPI.createMindMap(templateData);

      // 5. 更新收集區，設定 collectReferMindId 和 useTemplate
      const updateCollectData = {
        "cid": collectRes.id,
        "collectReferMindId": templateRes.id,
        "useTemplate": true,
        "editor": {
          "id": that.profile.teammodelId,
          "name": that.profile.name,
        },
      };
      await api.mindmapAPI.updateMindCollect(updateCollectData);

      // 6. 獲取簡碼
      const currentMindCollectURL = `${location.origin}/mindcollect?cid=${collectRes.id}`;
      const dataForClip = {
        "origDataList": [{ "origData": currentMindCollectURL }],
        "type": "mindmap",
        "useShortDigits": false,
        "isPermanent": false,
        "lang": that.$i18n.locale.toLowerCase(),
        "note": JSON.stringify({mindCollectName: collectData.mindCollectName})
      };

      const clipRes = await api.mindmapAPI.getClipCode(dataForClip);
      const clipCode = clipRes.clipCodePairs[0].clipCode;

      // 7. 最終更新收集區簡碼
      await api.mindmapAPI.updateMindCollect({
        "cid": collectRes.id,
        "mindCollectName": collectData.mindCollectName,
        "editor": {
          "id": that.profile.teammodelId,
          "name": that.profile.name,
        },
        "openSubmit": collectData.openSubmit,
        "allowViewOthers": collectData.allowViewOthers,
        "urlClipCode": clipCode,
        "collectType": "task",
        "collectReferMindId": templateRes.id,
        "useTemplate": true
      });

      // 8. 跳轉到收集區頁面
      router.push({
        name: "MindCollect",
        query: {
          cid: collectRes.id,
          showSetting: true
        }
      });

      return {
        collectId: collectRes.id,
        templateId: templateRes.id,
        clipCode: clipCode
      };

    } catch (error) {
      console.error('創建心智圖作業任務失敗:', error);
      throw error;
    } finally {
      // 確保容器資源被安全釋放
      if (container) {
        try {
          // 如果容器有未保存的變更，等待保存完成後再 dispose
          if (container.isDirty) {
            console.log('等待容器保存完成後釋放...');
            container.once("saved", () => {
              console.log("容器已保存，開始釋放資源");
              try {
                container.dispose();
              } catch (disposeError) {
                console.warn('釋放容器資源時發生錯誤:', disposeError);
              }
            });
          } else {
            // 容器沒有未保存的變更，直接釋放
            console.log("容器無未保存變更，直接釋放資源");
            container.dispose();
          }
        } catch (disposeError) {
          console.warn('釋放容器資源時發生錯誤:', disposeError);
        }
      }
    }
  };

  return {
    createMindCollectFromTemplate,
    getFluidMindData,
    initializeAzureClient
  };
}